import { ALL_WHATSAPP_TEMPLATES } from "../../constant/ActionType";

export default function WhatsappTemplatesReducer(
  state = {
    whatsappTemplates: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case ALL_WHATSAPP_TEMPLATES:
      return {
        ...state,
        whatsappTemplates: action.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
